export enum RoutesEnum {
  SUBSCRIPTION_PAYMENT = 'SUBSCRIPTION_PAYMENT',
  SUBSCRIPTION_CONFIRMATION = 'SUBSCRIPTION_CONFIRMATION',
  NEW_SUBSCRIPTION_CONFIRMATION = 'NEW_SUBSCRIPTION_CONFIRMATION',
  LISTS_RECOMMENDATIONS = 'LISTS_RECOMMENDATIONS',
  LEGAL_CONDITIONS = 'LEGAL_CONDITIONS',
  PRIVACY_POLICIES = 'PRIVACY_POLICIES',
  SUPPORT_NEW_REQUEST_URL = 'SUPPORT_NEW_REQUEST_URL',
  APP_STORE_URL = 'APP_STORE_URL',
  PLAY_STORE_URL = 'PLAY_STORE_URL',
  ESSENTIALS_COLLECTION = 'ESSENTIALS_COLLECTIONS',
  FRESH_COLLECTION = 'FRESH_COLLECTION',
  CGU = 'CGU',
  CGV = 'CGV',
  BLOG_URL = 'BLOG_URL',
  MAAP_CARD_IMAGE = 'MAAP_CARD_IMAGE',
  PRODUCT_PAGE = 'PRODUCT_PAGE',
  MANAGE_MY_SUBSCRIPTION = 'MANAGE_MY_SUBSCRIPTION',
}
